export default {"src":"/_next/static/media/82f9a2836d06afa40f3c9b1cefa86dfa.8e813bdb.svg","height":259,"width":669,"blurWidth":0,"blurHeight":0};